import { render, staticRenderFns } from "./LocaleMenu.vue?vue&type=template&id=21f4da18&"
import script from "./LocaleMenu.vue?vue&type=script&setup=true&lang=ts&"
export * from "./LocaleMenu.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports